import HttpService from "common/http/httpService";
import { ContractType } from "domain/contract";
import { DeliveryMethod } from "domain/deliveryMethod";

class DeliveryMethodService extends HttpService {
    async list(contractType: ContractType): Promise<DeliveryMethod[]> {
        const response = await this.getClient()
            .get<DeliveryMethod[]>("/offers/v1/delivery-methods", {
                params: {
                    contractType
                }
            });
        return response.data;
    }

}

const deliveryMethodService = new DeliveryMethodService();

export default deliveryMethodService;